import { ViewSummaryModel } from '../../../models/view.model';

export const ROUNDS_BY_FUND_VIEW_ID = 'rounds_by_fund';

/** Rounds by Fund is listed, opened and landed on only while showRoundsByFundView is on. */
export function visibleViews<T extends Pick<ViewSummaryModel, 'viewId'>>(
  views: T[],
  showRoundsByFundView: boolean | undefined
): T[] {
  return showRoundsByFundView ? views : views.filter((view) => view.viewId !== ROUNDS_BY_FUND_VIEW_ID);
}
